import { Logger } from './Logger';

export class LLMDebugger {
    private static instance: LLMDebugger;
    private logger: Logger;
    private debugMode: boolean;
    private debugData: Map<string, any>;

    private constructor() {
        this.logger = Logger.getInstance();
        this.debugMode = false;
        this.debugData = new Map();
    }

    static getInstance(): LLMDebugger {
        if (!LLMDebugger.instance) {
            LLMDebugger.instance = new LLMDebugger();
        }
        return LLMDebugger.instance;
    }

    setDebugMode(enabled: boolean): void {
        this.debugMode = enabled;
        this.logger.info('LLM_DEBUG_MODE', `LLM调试模式已${enabled ? '启用' : '禁用'}`);
    }

    logModelCall(modelId: string, data: any): void {
        if (!this.debugMode) return;
        
        this.debugData.set(`${modelId}_${Date.now()}`, data);
        this.logger.debug('LLM_CALL', `模型调用: ${modelId}`, data);
    }

    logModelResponse(modelId: string, response: any, error?: Error): void {
        if (!this.debugMode) return;

        const logData = {
            modelId,
            timestamp: new Date().toISOString(),
            success: !error,
            error: error ? {
                message: error.message,
                stack: error.stack
            } : undefined,
            response
        };

        this.debugData.set(`${modelId}_response_${Date.now()}`, logData);
        this.logger.debug('LLM_RESPONSE', `模型响应: ${modelId}`, logData);
    }

    logStreamChunk(modelId: string, chunk: any): void {
        if (!this.debugMode) return;

        this.logger.debug('LLM_STREAM', `流式响应片段: ${modelId}`, {
            timestamp: new Date().toISOString(),
            chunk
        });
    }

    getDebugData(modelId?: string): any[] {
        if (modelId) {
            return Array.from(this.debugData.entries())
                .filter(([key]) => key.startsWith(modelId))
                .map(([_, value]) => value);
        }
        return Array.from(this.debugData.values());
    }

    clearDebugData(): void {
        this.debugData.clear();
        this.logger.info('LLM_DEBUG_CLEAR', '已清除调试数据');
    }

    async analyzeError(error: Error, modelId: string, context: any): Promise<string> {
        const errorAnalysis = {
            timestamp: new Date().toISOString(),
            modelId,
            errorType: error.name,
            errorMessage: error.message,
            errorStack: error.stack,
            context
        };

        this.logger.error('LLM_ERROR_ANALYSIS', '模型错误分析', errorAnalysis);

        // 根据错误类型提供建议
        let suggestion = '建议的解决方案：\n';
        
        if (error.message.includes('rate limit')) {
            suggestion += '- 当前遇到速率限制，建议：\n';
            suggestion += '  1. 降低请求频率\n';
            suggestion += '  2. 检查API密钥配额\n';
            suggestion += '  3. 考虑使用备用模型\n';
        } else if (error.message.includes('timeout')) {
            suggestion += '- 请求超时，建议：\n';
            suggestion += '  1. 检查网络连接\n';
            suggestion += '  2. 增加超时时间\n';
            suggestion += '  3. 减少输入token数量\n';
        } else if (error.message.includes('invalid_api_key')) {
            suggestion += '- API密钥无效，建议：\n';
            suggestion += '  1. 检查API密钥是否正确\n';
            suggestion += '  2. 确认API密钥未过期\n';
            suggestion += '  3. 验证API密钥权限\n';
        }

        return suggestion;
    }
} 